// Enormous brass numeral that sits half off the left edge of the section.
// Purely typographic — the cheapest possible way to make a long page feel
// authored. Absolutely positioned; wrap a `relative` on the parent.
export default function BigSectionNo({ n, className = "" }) {
  return (
    <span
      aria-hidden="true"
      data-testid={`big-numeral-${n}`}
      className={`display pointer-events-none absolute -left-[6vw] top-4 select-none text-[22vw] font-light leading-none text-gold/[0.09] sm:-left-[3vw] sm:top-8 sm:text-[16vw] ${className}`}
      style={{ letterSpacing: "-0.04em" }}
    >
      {n}
    </span>
  );
}
